import './index.scss';
import Table from '../Table/Table';
import MobileTable from '../Table/MobileTable';
import '@styles/react/libs/react-select/_react-select.scss';
import '@styles/react/libs/tables/react-dataTable-component.scss';
import { SubscriptionManagement } from '../../../store/SubscriptionsManagement/subscriptionsManagementTypes';

interface TableContainerProps {
  data: any[];
  columns: any;
  rowsPerPage?: number;
  pagination: any;
  header?: any;
  onSort?: (column: any, direction: any) => void;
  onRemoveItemCallback?: (id: number) => void;
  onEditItemCallback?: (id: number) => void;
  onDuplicateItemCallback?: (id: number) => void;
  onSendMailCallback?: (user: any) => void;
  onOpenUsageListCallback?: (order: any) => void;
  onCancelMembershipCallback?: (
    id: number,
    subscription: SubscriptionManagement
  ) => void;
}

const TableContainer = (props: TableContainerProps) => {
  return (
    <div className="table-container-component">
      <div className="table-container-desktop">
        <Table {...props} />
      </div>
      <div className="table-container-mobile">
        <MobileTable {...props} />
      </div>
    </div>
  );
};

export default TableContainer;
